export default __webpack_public_path__ + "static/media/mensaje.b53ff130.mp3";